/// <amd-module name="TFS/Views/AboutPage/AboutPage" />
import React = require("react");
import * as Resources from "TFS/Views/AboutPage/Resources";
import { format } from "VSS/Core/Util/String";
import { Components, VssComponent } from "VSS/Platform/Layout";
import { IVssPageService } from "VSS/Platform/Page";
import { IVssPerformanceService } from "VSS/Platform/Performance";

class AboutPageComponent extends VssComponent {
    private _ttiMarked: boolean;

    public render(): JSX.Element {
        const pageData = this.context.pageContext.getService<IVssPageService>("IVssPageService").getData()!;
        return (
            <div className="about-page-content">
                <h2>{format(Resources.AboutFormat, pageData.isHosted ? Resources.ProductNameHosted : Resources.ProductNameOnPrem)}</h2>
                <p>{format(Resources.VersionFormat, pageData.serviceVersion)}</p>
                <p>{Resources.Copyright}</p>
            </div>
        );
    }

    public componentDidMount() {
        super.componentDidMount();

        if (!this._ttiMarked) {
            const performanceService = this.context.pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
            performanceService.markTimeToInteractive("tfs", "WebPlatform.AboutPage");

            this._ttiMarked = true;
        }
    }
}

Components.add("aboutPage", AboutPageComponent);
